import qs from 'query-string';
import omit from 'lodash/omit';
import includes from 'lodash/includes';

export default class QSUtil {
	static addToQs(key, value){
		let q = qs.parse(location.search)
		const s = qs.stringify({...q, [key]:value});
		return (!s) ? location.pathname : '?' + s;
	}

	static removeFromQs(key){
		let q = qs.parse(location.search)
		q = omit(q, [key]);
		const s = qs.stringify(q);
		return (!s) ? location.pathname : '?' + s;
	}

	static includes(key){
		return includes(Object.keys(qs.parse(location.search)), key);
	}

	static getValue(key){
		const keys = qs.parse(location.search);
		if(keys && key){
			return keys[key];
		}
		return null;
	}
}